import { createProductParameter } from "@iewcasia/Store/Handlers/Utilities/useProductParameter";
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";

interface Parameter {
    productId: string;
    qtyOrdered?: number;
    unitOfMeasure?: string;
    numberOfSpools?: number;
}

type HandlerType = Handler<Parameter>;

export const DispatchBeginLoadProduct: HandlerType = props => {
    throwErrorIfTesting();

    props.dispatch({
        type: "Custom/LoadingPrice/BeginLoadingPrice",
        productId: props.parameter.productId,
    } as any);
};

export const LoadRealTimePricing: HandlerType = props => {
    const productParameter = createProductParameter(props.parameter);
    if (!productParameter) {
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [productParameter],
            onSuccess: realTimePricing => {
                const pricing = realTimePricing.realTimePricingResults!.find(
                    o => o.productId === productParameter.productId,
                );
                if (pricing) {
                    props.dispatch({
                        type: "Pages/ProductList/CompleteLoadRealTimePricing",
                        realTimePricing,
                    });
                } else {
                    props.dispatch({
                        type: "Pages/ProductList/FailedLoadRealTimePricing",
                        productId: productParameter.productId,
                    });
                }

                props.dispatch({
                    type: "Custom/LoadingPrice/CompleteLoadingPrice",
                    productId: props.parameter.productId,
                } as any);
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductList/FailedLoadRealTimePricing",
                    productId: productParameter.productId,
                });
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
};

export const chain = [DispatchBeginLoadProduct, LoadRealTimePricing];

const updateProductInfoProductList = createHandlerChainRunner(chain, "UpdateProductInfoProductList");

export default updateProductInfoProductList;
